import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Avatar,
  Card,
  CardContent,
  useMediaQuery,
  Dialog,
  DialogTitle,
  Button,
} from "@mui/material";
import MyButton from "../../ui/MyButton";
import { getProfileTeacherById } from "../../../actions/profileTeacher";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import Spinner from "../../ui/Spinner";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import ShowMoreText from "react-show-more-text";
import getMinPeriodPrice from "../../../utils/getMinPeriodPrice";
import formatMoney from "../../../utils/formatMoney";
import { useHistory } from "react-router-dom";
import "./ReactPlayer.css";
import DateRangeIcon from "@mui/icons-material/DateRange";
import Reviews from "./Reviews";
import { Cloudinary } from "@cloudinary/url-gen";
import { useConfirm } from "material-ui-confirm";
import { Rating } from "@mui/material";
import styled from "@emotion/styled";
import SearchIcon from "@mui/icons-material/Search";
import { Box } from "@mui/system";

const StyledAvatar = styled(Avatar)({
  width: "100px",
  height: "100px",
});

const StyledCard = styled(Card)({
  padding: "0 10px",
});

const ReactPlayerWrapper = styled("div")({
  position: "relative",
  paddingTop: "56.25%" /* Player ratio: 100 / (1280 / 720) */,
});

const StyledReactPlayer = styled(ReactPlayer)({
  position: "absolute",
  top: "0",
  left: "0",
});

const ImageGrid = styled(Grid)({
  maxWidth: 300,
});

const Img = styled("img")({
  width: "100%",
  height: "auto",
});

const TeacherInfo = ({
  match,
  profileTeacher: { profileTeacher, loading },
  getProfileTeacherById,
  profileStudent: { profile },
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [openWatchMore, setOpenWatchMore] = useState(false);
  const [lessonContent, setLessonContent] = useState('');

  const history = useHistory();

  const confirm = useConfirm();

  const cld = new Cloudinary({
    cloud: {
      cloudName: "youspeak",
    },
  });

  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.up("md"));

  const executeOnClick = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    getProfileTeacherById(match.params.teacherProfileId);
  }, [getProfileTeacherById, match.params.teacherProfileId]);

  let cldVideo;
  let cldThumbnail;
  if (profileTeacher && profileTeacher.video) {
    const cldRes = cld.video(profileTeacher.video);
    cldVideo = cldRes.toURL();

    cldThumbnail = cldVideo.split("?")[0];
    cldThumbnail = cldThumbnail + ".jpg";
  }

  let cldTeacherAvatar;
  if (profileTeacher && profileTeacher.teacherAvatar) {
    const cldRes = cld.image(profileTeacher.teacherAvatar);

    cldTeacherAvatar = cldRes.toURL();
  }

  let cldDegreeImages = [];
  if (profileTeacher && profileTeacher.degreeImages.length > 0) {
    profileTeacher.degreeImages.forEach((image) => {
      const cldRes = cld.image(image);

      const cldDegreeImage = cldRes.toURL();

      cldDegreeImages.push(cldDegreeImage);
    });
  }

  const renderDegreeImages = (source) => {
    return source.map((photo, index) => {
      return (
        <ImageGrid item key={index}>
          <Img src={photo} alt="degree images" />
        </ImageGrid>
      );
    });
  };

  let cldExpImages = [];
  if (profileTeacher && profileTeacher.expImages.length > 0) {
    profileTeacher.expImages.forEach((image) => {
      const cldRes = cld.image(image);

      const cldExpImage = cldRes.toURL();

      cldExpImages.push(cldExpImage);
    });
  }

  const renderExpImages = (source) => {
    return source.map((photo, index) => {
      return (
        <ImageGrid item key={index}>
          <Img src={photo} alt="experience" />
        </ImageGrid>
      );
    });
  };

  const handleClickScheduleLesson = (userId) => {
    if (!profile) {
      confirm({
        title:
          "Bạn chưa điền thông tin cá nhân. Vui lòng điền thông tin cá nhân trước khi đặt lịch học. Nhấn OK để đến trang điền thông tin cá nhân",
      })
        .then(() => {
          history.push(`/create-profile`);
        })
        .catch(() => { });
    } else {
      history.push(`/book-learning-time/${userId}`);
    }
  };

  let averageRating = 0;
  if (profileTeacher && profileTeacher.averageRating) {
    averageRating = profileTeacher.averageRating;
  }

  const handleOpenWatchMore = (lessonContent) => {
    setOpenWatchMore((prevValue) => !prevValue);

    setLessonContent(lessonContent);
  };

  return (
    <>
      {loading || profileTeacher === null ? (
        <Spinner />
      ) : (
        <Grid
          container
          direction="column"
          alignItems="center"
          spacing={3}
          style={{ margin: "7em 0 2em", width: "100%", padding: "0 4em" }}
        >
          <Grid item>
            <Typography
              variant={matchesMD ? "h4" : "h5"}
              style={{
                textTransform: "uppercase",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Thông tin về giáo viên
            </Typography>
          </Grid>

          <Grid item style={{ minWidth: matchesMD ? "60%" : "100%" }}>
            {cldVideo && cldThumbnail && (
              <ReactPlayerWrapper>
                <StyledReactPlayer
                  url={cldVideo}
                  controls
                  playing
                  light={cldThumbnail}
                  width="100%"
                  height="100%"
                />
              </ReactPlayerWrapper>
            )}
          </Grid>

          <Grid
            item
            container
            direction={matchesMD ? "row" : "column"}
            alignItems="center"
            justifyContent="center"
            spacing={3}
          >
            <Grid item>
              {profileTeacher &&
                profileTeacher.lessons &&
                profileTeacher.lessons.length > 0 && (
                  <Card>
                    <CardContent>
                      <Grid
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography variant="h6">
                            Giá thấp nhất từ:
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body1">
                            {formatMoney(
                              Math.min(
                                ...profileTeacher.lessons.map(
                                  (lesson) =>
                                    lesson &&
                                    lesson.periods &&
                                    lesson.periods.length > 0 &&
                                    getMinPeriodPrice(lesson.periods[0])
                                )
                              )
                            )}
                            &nbsp;VNĐ
                          </Typography>
                        </Grid>
                        <Grid item>
                          <MyButton
                            onClick={() =>
                              handleClickScheduleLesson(profileTeacher.user._id)
                            }
                            style={{
                              fontWeight: "700",
                              color: "white",
                              background: "#b30000",
                            }}
                          >
                            <DateRangeIcon />
                            &nbsp;Đặt lịch học
                          </MyButton>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}
            </Grid>

            <Grid item>
              {profileTeacher.lessons.length > 0 && (
                <Card>
                  <CardContent>
                    <Grid container direction="column" justifyContent="center">
                      <Grid item sx={{ textAlign: "center" }}>
                        <Typography variant="h6">Các kiểu bài học:</Typography>
                      </Grid>
                      <Grid item container justifyContent="center" alignItems="center" direction='column' spacing={2}>
                        {profileTeacher.lessons.map((lesson, index) => (
                          <Grid
                            item
                            container
                            key={index}
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                          >
                            <Grid item>
                              <Typography variant="body1">
                                {index + 1}.&nbsp;
                                {lesson.lessonName}
                              </Typography>
                            </Grid>

                            <Grid item>
                              <Button
                                variant="contained"
                                sx={{ color: "white" }}
                                onClick={() => { handleOpenWatchMore(lesson.content) }}
                              >
                                <SearchIcon />
                                &nbsp; Xem thêm
                              </Button>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              )}
            </Grid>
          </Grid>

          <Grid item>
            <StyledCard>
              <CardContent>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={3}
                >
                  <Grid item>
                    {cldTeacherAvatar && (
                      <StyledAvatar
                        alt="teacher-avatar"
                        src={cldTeacherAvatar}
                      />
                    )}
                  </Grid>

                  <Grid item>
                    <Grid container direction="column" spacing={1}>
                      <Grid item>
                        {profileTeacher.user.name && (
                          <Typography variant="h6">
                            {profileTeacher.user.name}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item>
                        {profileTeacher.typeOfTeacher && (
                          <Typography variant="body1">
                            {profileTeacher.typeOfTeacher === "professional"
                              ? "Giáo viên chuyên nghiệp"
                              : "Giáo viên cộng đồng"}
                          </Typography>
                        )}
                      </Grid>

                      <Grid item>
                        <Typography variant="body1">
                          <Grid container alignItems="center">
                            <Grid item>
                              <Rating
                                value={averageRating}
                                readOnly
                                precision={0.5}
                              />
                            </Grid>

                            <Grid item>
                              ( Có{" "}
                              <strong>{profileTeacher.reviews.length}</strong>{" "}
                              đánh giá )
                            </Grid>
                          </Grid>
                        </Typography>
                      </Grid>

                      <Grid item>
                        {profileTeacher &&
                          profileTeacher.hometown &&
                          profileTeacher.hometown.label && (
                            <Typography variant="body1">
                              <strong>Đến từ:</strong>&nbsp;
                              {profileTeacher.hometown.label}
                            </Typography>
                          )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>
          </Grid>

          <Grid item style={{ maxWidth: matchesMD ? "80%" : undefined }}>
            <Card>
              <CardContent>
                <Grid container direction="column">
                  <Grid item sx={{ textAlign: "center" }}>
                    <Typography variant="h6">
                      Giới thiệu về giáo viên:
                    </Typography>
                  </Grid>
                  <Grid item>
                    {profileTeacher.introduction && (
                      <ShowMoreText
                        lines={3}
                        more="Xem thêm"
                        less="Thu lại"
                        onClick={executeOnClick}
                        expanded={isExpanded}
                        width={600}
                      >
                        <Typography variant="body1">
                          {profileTeacher.introduction}
                        </Typography>
                      </ShowMoreText>
                    )}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Show degree images of teacher */}
          {profileTeacher &&
            profileTeacher.degreeImages &&
            profileTeacher.degreeImages.length > 0 &&
            profileTeacher.typeOfTeacher !== "commutor" && (
              <Grid item>
                <Card>
                  <CardContent>
                    <Grid container direction="column">
                      <Grid item sx={{ textAlign: "center" }}>
                        <Typography variant="h6">
                          Ảnh bằng cấp của giáo viên:
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={3}
                        style={{ width: "100%", margin: "0" }}
                      >
                        {renderDegreeImages(cldDegreeImages)}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            )}

          {/* Show experience images of a teacher */}
          {profileTeacher &&
            profileTeacher.expImages &&
            profileTeacher.expImages.length > 0 &&
            profileTeacher.typeOfTeacher !== "commutor" && (
              <Grid item>
                <Card>
                  <CardContent>
                    <Grid container direction="column">
                      <Grid item sx={{ textAlign: "center" }}>
                        <Typography variant="h6">
                          Ảnh kinh nghiệm của giáo viên:
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={3}
                        style={{ width: "100%", margin: "0" }}
                      >
                        {renderExpImages(cldExpImages)}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            )}

          <Grid item>
            <Reviews teacherId={match.params.teacherProfileId} />
          </Grid>

          {lessonContent && <Dialog
            open={openWatchMore}
            onClose={() => { handleOpenWatchMore('') }}
          >
            <DialogTitle sx={{ textAlign: "center" }}>
              Nội dung bài học
            </DialogTitle>
            <Box
              component="div"
              sx={{ padding: "0 2em 2em 2em" }}
            >
              <Typography variant="body1">
                {lessonContent}
              </Typography>
            </Box>
            <Box
              sx={{ textAlign: "center", marginBottom: "1em" }}
            >
              <Button
                variant="contained"
                onClick={() => { handleOpenWatchMore('') }}
                sx={{ color: "white" }}
              >
                Đóng
              </Button>
            </Box>
          </Dialog>}
        </Grid>
      )}
    </>
  );
};

TeacherInfo.propTypes = {
  getProfileTeacherById: PropTypes.func.isRequired,
  profileTeacher: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  profileTeacher: state.profileTeacher,
  profileStudent: state.profileStudent,
});

export default connect(mapStateToProps, { getProfileTeacherById })(TeacherInfo);
